/* eslint-disable */
/*
 * KOPYA: Asıl motor backend'de modules/konteyner-planlama/engine/packer.js.
 * Frontend bu kopyayı yalnızca satır hesapları (paket kg, paket eni, yerleşim seçenekleri)
 * ve sabitler için kullanır; planı backend hesaplar. Motor değişirse ikisi birlikte güncellenmeli.
 *
 * Konteyner 3D yerleşim motoru
 * --------------------------------------------------------------
 * Hesap kuralları KonteynerPlanlama.js'den alındı:
 *   - DENSITY = 7.85
 *   - paketKg = 7.85 * kalınlık * bantEni * boy * paketİçi / 1e6
 *   - paketSayısı = floor(adet / paketİçi), kalan = adet - paketSayısı*paketİçi
 *   - paketEni = ebat * katsayı (PAKET_ICI_MAP), paket yüksekliği = paketEni * 0.877
 *
 * Fiziksel model:
 *   - Paketler konteyner boyuna (x) yatırılır; ürün boyu = paket uzunluğu.
 *   - DÜZ dizilim: kesitte serbest yüzey yöntemiyle en × kat. Her paket tabana
 *     (taban takozu üstüne) ya da alttaki paketlerin üstüne (ara takoz ile) tam oturur.
 *   - PETEK (bal peteği) dizilim: demetler köşesi yukarı çevrilir, sıralar
 *     birbirinin oluğuna oturur (dikey adım = 0,75 × köşe-köşe), tek sıralar yarım
 *     paket kaydırılır. Ara takoz kullanılmaz. Bir petek bloğu tabana oturur.
 *   - Müşteri kuralı: farklı boylar üst üste yüklenmez (açılıp kapatılabilir).
 *   - Yükseklik limiti = min(iç yükseklik, kapı yüksekliği): paket kapıdan girer.
 *   - Ağırlık limiti konteyner başına maxKg.
 *
 * Tarayıcıda window.Packer, Node'da module.exports olarak çalışır.
 */
(function (root, factory) {
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.Packer = factory();
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  const DENSITY = 7.85;
  const HEX_RATIO = 0.877;
  const PETEK_PITCH = 0.75; // altıgen petek: sıra adımı = 0,75 × köşe-köşe yükseklik
  const PAKET_ICI_MAP = { 37: 7, 61: 9, 91: 11, 127: 13, 169: 15, 217: 17, 271: 19, 331: 21, 397: 23 };

  // İç ölçüler (mm). maxKg sizin koddaki 25.000 kg varsayılanı.
  const CONTAINER_TYPES = {
    "20DC": { name: "20' DC", L: 5898, W: 2352, H: 2393, doorH: 2280, maxKg: 25000 },
    "40DC": { name: "40' DC", L: 12032, W: 2352, H: 2393, doorH: 2280, maxKg: 25000 },
    "40HC": { name: "40' HC", L: 12032, W: 2352, H: 2698, doorH: 2585, maxKg: 25000 },
  };

  // Müşteri yükleme talimatları
  // Müşteri yükleme talimatları. Her kural arayüzde işaretli/işaretsiz gelir, kullanıcı değiştirebilir.
  //   tip "farkliBoyYasak": farklı boylar üst üste yüklenmez
  //   tip "petekIzin": petek (bal peteği) dizilim denenebilir
  //   tip "enineIzin": boyu konteyner eninden kısa ürünler enine yüklenebilir
  //   tip "zorunlu": eşleşen ürün belirtilen dizilimle yüklenir
  const ORTAK_KURALLAR = (farkliBoy, madde) => [
    { id: "farkliBoy", tip: "farkliBoyYasak", ad: "Farklı boy malzemeler üst üste yüklenmez", varsayilan: farkliBoy, madde },
    { id: "petek", tip: "petekIzin", ad: "Petek (bal peteği) dizilim kullanılabilir", varsayilan: true },
    { id: "enine", tip: "enineIzin", ad: "Enine yükleme yapılabilir (boy ≤ konteyner iç eni)", varsayilan: true },
  ];
  const MUSTERI_PROFILLERI = {
    genel: {
      ad: "Genel (müşteri talimatı yok)",
      konteyner: "40HC", tabanTakoz: 0, araTakoz: 0, yanBosluk: 0,
      kurallar: ORTAK_KURALLAR(false),
      talimat: [],
    },
    ramsteel: {
      ad: "Ramsteel · PR05-TA89",
      kaynak: "PR05-TA89 Ramsteel Yükleme Talimatı, Rev. 0, 11.09.2026",
      konteyner: "40HC", tabanTakoz: 210, araTakoz: 30, yanBosluk: 50,
      kurallar: [
        ...ORTAK_KURALLAR(true, "Madde 6"),
        { id: "q35petek", tip: "zorunlu", ad: "Q35 × 2970 bal peteği şeklinde yüklenir", ebat: 35, boy: 2970, dizilim: "petek", varsayilan: true, madde: "Madde 7" },
      ],
      talimat: [
        "3 m ve üzeri boylarda lashing halatları, platform ilerlerken kopmaması için taban takozuna takılmadan serilir.",
        "Taban takozu 21 cm; takoz ve yan yüklemelerde 8×8 ahşap kullanılır.",
        "TR 2300 polyester dokuma lashing halatı (2.469 daN çekme mukavemeti) kullanılır.",
        "Beyaz sapan (sonsuz ihracat sapanı) kullanılır.",
        "3×10 ara takozlar ve tüm taban takozları VCI kâğıdına sarılır.",
        "Farklı boy malzemeler üst üste yüklenmez.",
        "Q35 × 2970 bal peteği şeklinde yüklenir.",
        "Bağlama yerleri müşteri talebine göre: kapı tarafındaki halat paket ucundan en fazla 400 mm, taban takozu uçtan 150 mm.",
        "Lashing adedi CTU Code hesabına göre (PR05-TA74). Örnek: Q38 platform 9 / konteyner içi 0; Q35×2970 platform 8 / konteyner içi 4 halat.",
      ],
    },
    northwest: {
      ad: "NorthWest · PR05-TA90",
      kaynak: "PR05-TA90 NorthWest Yükleme Talimatı, Rev. 0, 11.09.2026",
      konteyner: "40HC", tabanTakoz: 210, araTakoz: 30, yanBosluk: 50,
      kurallar: [
        { id: "farkliBoy", tip: "farkliBoyYasak", ad: "Farklı boy malzemeler üst üste yüklenmez", varsayilan: true, madde: "Madde 6" },
        { id: "q38duz", tip: "zorunlu", ad: "Q38 düz dizilimle (ara takozlu katlar) yüklenir", ebat: 38, dizilim: "duz", varsayilan: true, madde: "Madde 2" },
        { id: "enine", tip: "enineIzin", ad: "Enine yükleme yapılabilir (boy ≤ konteyner iç eni)", varsayilan: true, madde: "Madde 2" },
        { id: "petek", tip: "petekIzin", ad: "Petek (bal peteği) dizilim kullanılabilir", varsayilan: false },
        { id: "hafif", tip: "hafifUstte", ad: "Ağır paket hafif paketin üstüne konmaz (hafif paketler üstte)", varsayilan: true, madde: "Uygulama" },
      ],
      talimat: [
        "Yükleme şekilleri ebada göre talimat çizimlerindeki gibi: Q38 düz, katlar arasında 3×10 ara takoz.",
        "Taban takozu 21 cm; takoz ve yan yüklemelerde 8×8 ahşap kullanılır.",
        "Farklı boy malzemeler üst üste yüklenmez.",
        "Halat adedi: Q38 platform 9 / konteyner içi 0; Q38 × 2955 platform 8 / konteyner içi 0.",
      ],
    },
  };

  /**
   * Kural listesi + kullanıcının açıp kapattıkları -> motor seçenekleri.
   * kural: { id, tip, ad, madde?, varsayilan?, parametreler?: { ebat, boy, dizilim, yon } }
   * Desteklenen tipler: farkliBoyYasak, petekIzin, enineIzin, hafifUstte, zorunluDizilim (eski adı: zorunlu).
   * aktif: { kuralId: bool } — verilmeyen kural varsayılan durumunda kalır.
   */
  function kuralOpts(kurallar = [], aktif = {}) {
    const on = (k) => (aktif[k.id] ?? k.varsayilan) !== false;
    const list = kurallar.filter(on);
    const num = (v) => (v === "" || v == null ? null : toNum(v));
    return {
      farkliBoyUstUste: !list.some((k) => k.tip === "farkliBoyYasak"),
      petekIzin: list.some((k) => k.tip === "petekIzin"),
      hafifUstte: list.some((k) => k.tip === "hafifUstte"),
      enineIzin: list.some((k) => k.tip === "enineIzin"),
      zorunlu: list
        .filter((k) => k.tip === "zorunluDizilim" || k.tip === "zorunlu")
        .map((k) => {
          const p = k.parametreler || k;
          return { ebat: num(p.ebat), boy: num(p.boy), dizilim: p.dizilim || "petek", yon: p.yon || undefined, madde: `${k.madde ? k.madde + ": " : ""}${k.ad}` };
        }),
    };
  }

  /** Örnek profil + kullanıcının işaretlediği kurallar -> motor seçenekleri. */
  function profilOpts(profilKey, aktif = {}) {
    const pr = MUSTERI_PROFILLERI[profilKey] || MUSTERI_PROFILLERI.genel;
    return kuralOpts(pr.kurallar, aktif);
  }

  const EPS = 0.5;

  function toNum(v) {
    if (v === "" || v === null || v === undefined) return 0;
    const n = Number(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  }
  // yerleşmiş paketin konum alanları (yeniden yerleştirmeden önce silinir)
  const YERLESIM_ALANLARI = ["x", "y", "z", "container", "blockId"];
  function omit(o, keys) {
    const r = { ...o };
    for (const k of keys) delete r[k];
    return r;
  }

  function round(v, d = 2) {
    const f = 10 ** d;
    return Math.round((v + Number.EPSILON) * f) / f;
  }

  // altıgen demet: en geniş sırada k adet (k tek) -> toplam 3m(m+1)+1, m=(k-1)/2
  function hexCount(k) {
    const m = (k - 1) / 2;
    return 3 * m * (m + 1) + 1;
  }
  function katsayiFor(paketIci) {
    return PAKET_ICI_MAP[paketIci] || 0;
  }
  function smallestHexFor(n) {
    let k = 1;
    while (hexCount(k) < n) k += 2;
    return k;
  }

  /** Bir satırın hesaplanmış değerleri (tablodaki gri sütunlar). */
  function calcRow(row) {
    const kalinlik = toNum(row.kalinlik);
    const ebat = toNum(row.ebat);
    const boy = toNum(row.boy);
    const paketIci = toNum(row.paketIci);
    const bantEni = toNum(row.bantEni);
    const adet = toNum(row.adet);

    const parcaKg = kalinlik > 0 && bantEni > 0 && boy > 0 ? (DENSITY * kalinlik * bantEni * boy) / 1e6 : 0;
    const paketKgRaw = paketIci > 0 ? parcaKg * paketIci : 0;
    const paketSayisi = paketIci > 0 ? Math.floor(adet / paketIci) : 0;
    const kalanAdet = paketIci > 0 ? adet - paketSayisi * paketIci : 0;
    const katsayi = katsayiFor(paketIci);
    const paketEni = katsayi > 0 ? round(ebat * katsayi, 0) : 0;
    const paketYuk = paketEni > 0 ? round(paketEni * HEX_RATIO, 0) : 0;
    const totalKg = paketKgRaw * paketSayisi;

    return {
      kalinlik, ebat, boy, paketIci, bantEni, adet,
      parcaKg, paketKgRaw, paketKg: round(paketKgRaw, 0),
      paketSayisi, kalanAdet, katsayi, paketEni, paketYuk,
      totalKg, totalTons: round(totalKg / 1000, 1),
    };
  }

  function usable(cont, opts) {
    const side = toNum(opts.yanBosluk);
    const taban = toNum(opts.tabanTakoz ?? opts.takoz);
    const ara = toNum(opts.araTakoz ?? opts.takoz);
    // tavana en az bırakılacak boşluk: boşaltmada forklift paketi üstteki halatlardan kaldırır
    const minTavan = Math.max(0, toNum(opts.minTavanBosluk));
    return {
      L: cont.L,
      W: cont.W - side,
      H: Math.min(cont.H - minTavan, cont.doorH || cont.H),
      minTavan,
      yOff: side / 2,
      maxKg: cont.maxKg,
      taban,
      ara,
      farkliBoyYasak: opts.farkliBoyUstUste === false,
      // ağır paket hafif paketin üstüne konmaz (boşaltmada hafif paketler üstten önce alınır)
      hafifUstte: !!opts.hafifUstte,
    };
  }

  // Yerleşim modları: dizilim (düz/petek) × yön (boyuna/enine)
  const MODLAR = ["duz-boyuna", "petek-boyuna", "duz-enine", "petek-enine"];
  const MOD_ADI = { "duz-boyuna": "Düz · boyuna", "petek-boyuna": "Petek · boyuna", "duz-enine": "Düz · enine", "petek-enine": "Petek · enine" };
  const normMod = (m) => (m === "duz" ? "duz-boyuna" : m === "petek" ? "petek-boyuna" : m);

  /**
   * Petek kesiti: demet köşesi yukarı. wf = yatay (yüz-yüz) = paket yüksekliği,
   * hc = dikey (köşe-köşe) = paket eni. Sıra adımı 0,75 × hc, tek sıralar wf/2 kayık.
   * span: sıranın dizildiği yatay açıklık (boyunada konteyner eni, eninede bir bölüm boyu).
   */
  function petekGeom(wf, hc, U, n = Infinity, span = U.W) {
    const avail = U.H - U.taban;
    let rows = 0;
    while (hc + rows * PETEK_PITCH * hc <= avail + EPS) rows++;
    const a = Math.floor((span + EPS) / wf);
    const b = Math.floor((span - wf / 2 + EPS) / wf);
    const offsets = [];
    let width = 0, height = 0;
    for (let r = 0; r < rows && offsets.length < n; r++) {
      const cnt = r % 2 ? b : a;
      const s0 = r % 2 ? wf / 2 : 0;
      for (let j = 0; j < cnt && offsets.length < n; j++) {
        offsets.push({ d: s0 + j * wf, dz: r * PETEK_PITCH * hc });
        width = Math.max(width, s0 + (j + 1) * wf);
        height = Math.max(height, r * PETEK_PITCH * hc + hc);
      }
    }
    const cap = Array.from({ length: rows }, (_, r) => (r % 2 ? b : a)).reduce((s, x) => s + x, 0);
    return { rows, a, b, cap, offsets, width, height };
  }
  const ENINE_SPAN = (U) => U.W; // enine petek bloğu boyda bir konteyner eni kadar yer kaplar

  /** Moda göre paketin konteyner eksenlerindeki ölçüleri (x = boy yönü, y = en, z = yükseklik). */
  function extents(mod, boy, eni, yuk) {
    switch (mod) {
      case "petek-boyuna": return { len: boy, w: yuk, h: eni };
      case "duz-enine": return { len: eni, w: boy, h: yuk };
      case "petek-enine": return { len: yuk, w: boy, h: eni };
      default: return { len: boy, w: eni, h: yuk };
    }
  }

  /** Bu modun bu konteynere sığıp sığmadığı; sığmıyorsa nedeni. */
  function modSigar(mod, c, U) {
    const e = extents(mod, c.boy, c.paketEni, c.paketYuk);
    if (mod.startsWith("petek")) {
      const g = petekGeom(c.paketYuk, c.paketEni, U, Infinity, mod.endsWith("enine") ? ENINE_SPAN(U) : U.W);
      if (g.rows < 1 || g.a < 1) return `petek sığmıyor (köşe-köşe ${c.paketEni} mm, kullanılabilir yükseklik ${U.H - U.taban} mm)`;
    } else if (e.h + U.taban > U.H + EPS) return `paket yüksekliği ${e.h} mm + taban takozu ${U.taban} mm > ${U.H} mm`;
    if (e.len > U.L + EPS) return mod.endsWith("enine") ? `paket eni ${e.len} mm > konteyner boyu` : `boy ${c.boy} mm > konteyner iç boyu (${U.L} mm)`;
    if (e.w > U.W + EPS) return mod.endsWith("enine") ? `boy ${c.boy} mm > kullanılabilir en (${U.W} mm)` : `paket eni ${c.paketEni} mm > kullanılabilir en (${U.W} mm)`;
    return null;
  }

  /**
   * Satır için denenebilecek modlar:
   *  1) satırda elle seçilmişse yalnız o,
   *  2) aktif bir zorunlu kural eşleşiyorsa (ör. Ramsteel Madde 7) o kuralın dizilimi,
   *  3) aksi halde izinli dizilim × izinli yön kombinasyonları.
   */
  function rowModes(row, c, opts) {
    const sel = normMod(row.yerlesim || row.dizilim || "otomatik");
    if (MODLAR.includes(sel)) return { modlar: [sel], kaynak: "satırda seçildi" };
    for (const k of opts.zorunlu || []) {
      if ((k.ebat == null || Math.abs(k.ebat - c.ebat) < 1e-6) && (k.boy == null || Math.abs(k.boy - c.boy) < 1e-6)) {
        const yonler = k.yon ? [k.yon] : ["boyuna", ...(opts.enineIzin ? ["enine"] : [])];
        return { modlar: yonler.map((y) => `${k.dizilim}-${y}`), kaynak: k.madde || "müşteri kuralı" };
      }
    }
    const diz = ["duz", ...(opts.petekIzin ? ["petek"] : [])];
    const yon = ["boyuna", ...(opts.enineIzin ? ["enine"] : [])];
    const modlar = [];
    for (const y of yon) for (const d of diz) modlar.push(`${d}-${y}`);
    return { modlar, kaynak: "otomatik" };
  }

  /** Satırları tek tek paketlere açar, sığmayanları hata olarak işaretler. */
  function buildPackages(rows, cont, opts = {}) {
    const U = usable(cont, opts);
    const pkgs = [];
    const rowInfo = {};
    for (const row of rows) {
      const c = calcRow(row);
      const info = { calc: c, errors: [], warnings: [], packages: 0, partial: null, dizilim: "duz", yon: "boyuna", mod: "duz-boyuna", modlar: [], dizilimKaynak: "" };
      rowInfo[row.id] = info;

      const empty = !c.kalinlik && !c.ebat && !c.boy && !c.adet;
      if (empty) continue;
      if (!c.kalinlik || !c.ebat || !c.boy || !c.bantEni || !c.adet || !c.paketIci) {
        info.errors.push("Eksik veri: kalınlık, ebat, boy, paket içi, bant eni ve adet dolu olmalı.");
        continue;
      }
      if (!c.katsayi) {
        info.errors.push(`Paket içi ${c.paketIci} katsayı tablosunda yok.`);
        continue;
      }
      if (c.paketSayisi === 0 && opts.kalanMode !== "paket") {
        info.errors.push(`Adet (${c.adet}) bir paketi (${c.paketIci}) doldurmuyor.`);
        continue;
      }
      const rm = rowModes(row, c, opts);
      const reasons = {};
      const modlar = rm.modlar.filter((m) => !(reasons[m] = modSigar(m, c, U)));
      info.dizilimKaynak = rm.kaynak;
      info.modlar = modlar;
      // kullanılamayan yöntemler ve nedeni (arayüzde gösterilir)
      info.redler = Object.fromEntries(rm.modlar.filter((m) => reasons[m]).map((m) => [m, reasons[m]]));
      if (opts.enineIzin && rm.kaynak === "otomatik" && !rm.modlar.some((m) => m.endsWith("enine") && !reasons[m])) {
        info.enineNeden = `enine olmaz: boy ${c.boy} mm > kullanılabilir en ${U.W} mm`;
      }
      if (!modlar.length) {
        info.errors.push(`Sığmıyor: ${rm.modlar.map((m) => `${MOD_ADI[m]}: ${reasons[m]}`).join("; ")}.`);
        continue;
      }
      const want = opts.modeMap?.[row.id];
      const mod = modlar.includes(want) ? want : modlar[0];
      info.mod = mod;
      [info.dizilim, info.yon] = mod.split("-");
      if (c.paketKgRaw > U.maxKg + EPS) { info.errors.push(`Tek paket ${round(c.paketKgRaw, 0)} kg, konteyner limitini (${U.maxKg} kg) aşıyor.`); continue; }

      const petek = info.dizilim === "petek";
      const enine = info.yon === "enine";
      if (petek) {
        const g = petekGeom(c.paketYuk, c.paketEni, U, Infinity, enine ? ENINE_SPAN(U) : U.W);
        info.petek = { rows: g.rows, a: g.a, b: g.b, cap: g.cap };
      }
      const list = [];
      for (let i = 0; i < c.paketSayisi; i++) list.push({ kg: c.paketKgRaw, eni: c.paketEni, yuk: c.paketYuk, pieces: c.paketIci, k: c.katsayi, partial: false });
      if (c.kalanAdet > 0) {
        if (opts.kalanMode === "paket") {
          const k = smallestHexFor(c.kalanAdet);
          const eni = round(c.ebat * k, 0);
          const yuk = k === 1 ? eni : round(eni * HEX_RATIO, 0);
          list.push({ kg: c.parcaKg * c.kalanAdet, eni, yuk, pieces: c.kalanAdet, k, partial: true });
          info.partial = { pieces: c.kalanAdet, k, w: eni, h: yuk };
        } else {
          info.warnings.push(`${c.kalanAdet} adet parça pakete girmedi, plana dahil değil.`);
        }
      }
      // karma yön: düz dizilimde, öteki yön de izinli ve sığıyorsa paket boşluğa göre döndürülebilir
      const altMod = !petek && opts.enineIzin && opts.karmaYon !== false && rm.kaynak !== "satırda seçildi" ? (enine ? "duz-boyuna" : "duz-enine") : null;
      const altOk = altMod && !modSigar(altMod, c, U);
      if (altOk) info.karmaYon = altMod;
      list.forEach((p, i) => {
        const { eni, yuk, ...rest } = p;
        const tk = p.partial ? `${row.id}~k${p.k}` : row.id;
        pkgs.push({
          id: `${row.id}#${i}`,
          rowId: String(row.id),
          typeKey: `${tk}~${mod}`,
          mod, petek, enine,
          boy: c.boy,
          eni, yuk,
          ...rest,
          ...extents(mod, c.boy, eni, yuk),
          alt: altOk ? { mod: altMod, enine: altMod.endsWith("enine"), typeKey: `${tk}~${altMod}`, ...extents(altMod, c.boy, eni, yuk) } : null,
        });
      });
      info.packages = list.length;
    }
    return { pkgs, rowInfo, U };
  }

  // ---------------------------------------------------------------- yerleşim birimleri
  // Düz paket tek başına bir birimdir. Petek satırının paketleri, bir kesiti
  // dolduran bloklar halinde yerleştirilir.

  let blockSeq = 0;
  const geomOf = (p0, U, n = Infinity) => petekGeom(p0.yuk, p0.eni, U, n, p0.enine ? ENINE_SPAN(U) : U.W);
  function makeBlock(members, U) {
    const p0 = members[0];
    const g = geomOf(p0, U, members.length);
    return {
      block: true,
      enine: p0.enine,
      id: `B${++blockSeq}`,
      rowId: p0.rowId,
      typeKey: p0.typeKey,
      boy: p0.boy,
      // boyuna: petek kesiti konteyner eninde; enine: konteyner boyunda bir bölüm
      len: p0.enine ? g.width : p0.len,
      w: p0.enine ? p0.w : g.width,
      h: g.height,
      kg: members.reduce((s, m) => s + m.kg, 0),
      unitKg: p0.kg,
      members,
      offsets: g.offsets.map((o) => (p0.enine ? { dx: o.d, dy: 0, dz: o.dz } : { dx: 0, dy: o.d, dz: o.dz })),
      partial: false,
    };
  }

  /** Aynı tipteki petek bloklarını birleştirip tam kesitlik bloklara yeniden böler. */
  function rechunk(blocks, U) {
    const members = blocks.flatMap((b) => b.members);
    if (!members.length) return [];
    const cap = geomOf(members[0], U).cap;
    const out = [];
    for (let i = 0; i < members.length; i += cap) out.push(makeBlock(members.slice(i, i + cap), U));
    return out;
  }

  function makeItems(pkgs, U) {
    const items = [];
    const petekGroups = new Map();
    for (const p of pkgs) {
      if (!p.petek) { items.push(p); continue; }
      const key = p.typeKey;
      if (!petekGroups.has(key)) petekGroups.set(key, []);
      petekGroups.get(key).push(p);
    }
    for (const list of petekGroups.values()) {
      const cap = geomOf(list[0], U).cap;
      for (let i = 0; i < list.length; i += cap) items.push(makeBlock(list.slice(i, i + cap), U));
    }
    return items;
  }

  // ---------------------------------------------------------------- yerleşim
  // Serbest yüzey yöntemi: konteyner tabanı tek bir yüzeyle başlar. Birim bir
  // yüzeyin köşesine oturur, yüzey üç parçaya bölünür (birimin üstü, yanındaki
  // şerit, boyda kalan kısım). Birim tamamen tek bir yüzeye oturduğu için alttan
  // destek garantilidir; aynı yükseklikteki komşu yüzeyler birleştirilir.
  // Yüzey, altındaki paketlerin boyunu (len0) taşır: "farklı boy üst üste
  // yüklenmez" kuralı bununla uygulanır.

  function newContainer(no, U) {
    return { no, kg: 0, placed: [], surfaces: [{ x: 0, len: U.L, y: U.yOff, w: U.W, z: 0, len0: null, yon0: null, kg0: null }] };
  }

  function mergeSurfaces(list) {
    let changed = true;
    while (changed) {
      changed = false;
      outer: for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (i === j) continue;
          const a = list[i], b = list[j];
          if (Math.abs(a.z - b.z) > EPS || a.len0 !== b.len0 || a.yon0 !== b.yon0) continue;
          // birleşen yüzey, altındaki en hafif paketin ağırlığını taşır
          const kg0 = a.kg0 == null || b.kg0 == null ? (a.kg0 ?? b.kg0 ?? null) : Math.min(a.kg0, b.kg0);
          if (Math.abs(a.x - b.x) < EPS && Math.abs(a.len - b.len) < EPS && Math.abs(a.y + a.w - b.y) < EPS) {
            a.w += b.w; a.kg0 = kg0; list.splice(j, 1); changed = true; break outer;
          }
          if (Math.abs(a.y - b.y) < EPS && Math.abs(a.w - b.w) < EPS && Math.abs(a.x + a.len - b.x) < EPS) {
            a.len += b.len; a.kg0 = kg0; list.splice(j, 1); changed = true; break outer;
          }
        }
      }
    }
  }

  function findSpot(c, p, U, ignoreWeight = false) {
    if (!ignoreWeight && c.kg + p.kg > U.maxKg + 1e-6) return null;
    let best = null;
    for (let i = 0; i < c.surfaces.length; i++) {
      const s = c.surfaces[i];
      if (p.len > s.len + EPS || p.w > s.w + EPS) continue;
      const onFloor = s.z < EPS;
      if (p.block && !onFloor) continue;
      if (!onFloor && U.farkliBoyYasak && s.len0 != null && Math.abs(s.len0 - p.boy) > EPS) continue;
      // boyuna paketin üstüne enine (ya da tersi) çapraz kat konmaz
      if (!onFloor && s.yon0 != null && s.yon0 !== !!p.enine) continue;
      if (!onFloor && U.hafifUstte && s.kg0 != null && p.kg > s.kg0 + 1) continue;
      const z = s.z + (onFloor ? U.taban : U.ara);
      if (z + p.h > U.H + EPS) continue;
      // "alttan": önce en alçak yüzey (tabanı yay); "duvar": arka duvardan kapıya bölüm bölüm
      const score = U.yontem === "duvar"
        ? [s.x, s.z, s.w - p.w, s.len - p.len, s.y]
        : [s.z, s.w - p.w, s.x, s.len - p.len, s.y];
      if (!best || lexLess(score, best.score)) best = { i, s, z, score };
    }
    return best;
  }

  function commit(c, p, U, spot) {
    const { s, z } = spot;
    c.surfaces.splice(spot.i, 1);
    let placed;
    if (p.block) {
      placed = p.members.map((m, i) => ({ ...m, container: c.no, x: s.x + p.offsets[i].dx, y: s.y + p.offsets[i].dy, z: z + p.offsets[i].dz, blockId: p.id }));
      c.placed.push(...placed);
    } else {
      placed = { ...p, container: c.no, x: s.x, y: s.y, z };
      c.placed.push(placed);
    }
    c.kg += p.kg;
    const top = z + p.h;
    if (!p.block && U.H - top >= 50) c.surfaces.push({ x: s.x, len: p.len, y: s.y, w: p.w, z: top, len0: p.boy, yon0: !!p.enine, kg0: p.kg });
    if (s.w - p.w >= 50) c.surfaces.push({ x: s.x, len: p.len, y: s.y + p.w, w: s.w - p.w, z: s.z, len0: s.len0, yon0: s.yon0, kg0: s.kg0 });
    if (s.len - p.len >= 300) c.surfaces.push({ x: s.x + p.len, len: s.len - p.len, y: s.y, w: s.w, z: s.z, len0: s.len0, yon0: s.yon0, kg0: s.kg0 });
    mergeSurfaces(c.surfaces);
    return placed;
  }

  function tryPlace(c, p, U) {
    const spot = findSpot(c, p, U);
    return spot ? commit(c, p, U, spot) : null;
  }

  /** Paketin öteki yöndeki hali (karma yön). */
  const altOf = (p) => (p.alt ? { ...p, ...p.alt, alt: null } : null);

  /** Önce asıl yönde, sığmazsa öteki yönde yerleştirir. */
  function tryPlaceAny(c, p, U) {
    return tryPlace(c, p, U) || (p.alt ? tryPlace(c, altOf(p), U) : null);
  }

  /** Ağırlıktan sığmayan petek bloğunu bölerek yerleştirir. Kalan bloğu döndürür. */
  function placeSplit(c, p, U) {
    if (!p.block) return null;
    const spot = findSpot(c, p, U, true);
    if (!spot) return null;
    const n = Math.floor((U.maxKg - c.kg + 1e-6) / p.unitKg);
    if (n < 1) return null;
    const head = makeBlock(p.members.slice(0, n), U);
    const sp = findSpot(c, head, U);
    if (!sp) return null;
    commit(c, head, U, sp);
    return makeBlock(p.members.slice(n), U);
  }

  function lexLess(a, b) {
    for (let i = 0; i < a.length; i++) {
      if (a[i] < b[i] - 1e-9) return true;
      if (a[i] > b[i] + 1e-9) return false;
    }
    return false;
  }

  const STRATEGIES = {
    "boy-en-kg": (a, b) => b.len - a.len || b.w - a.w || b.kg - a.kg,
    "kg": (a, b) => b.kg - a.kg || b.len - a.len,
    "kesit": (a, b) => b.w * b.h - a.w * a.h || b.len - a.len || b.kg - a.kg,
    "boy-kg": (a, b) => b.len - a.len || b.kg - a.kg || b.w - a.w,
    "yogunluk": (a, b) => b.kg / (b.w * b.h * b.len) - a.kg / (a.w * a.h * a.len) || b.len - a.len,
  };

  // mode "first": ilk sığan konteyner; "best": sığanlar içinde en dolu olan
  function packOnce(pkgs, U, cmp, mode = "first", rowRank = null) {
    const items = makeItems(pkgs, U);
    const queue = items
      .map((p, idx) => ({ p, idx }))
      .sort((A, B) =>
        (rowRank ? rowRank[A.p.rowId] - rowRank[B.p.rowId] : 0) ||
        cmp(A.p, B.p) || (A.p.partial - B.p.partial) || A.p.rowId.localeCompare(B.p.rowId) || A.idx - B.idx)
      .map((x) => x.p);
    const containers = [];
    const unplaced = [];
    while (queue.length) {
      const p = queue.shift();
      let target = null, spot = null;
      for (const c of containers) {
        const sp = findSpot(c, p, U);
        if (!sp) continue;
        if (mode === "first") { target = c; spot = sp; break; }
        if (!target || c.kg > target.kg) { target = c; spot = sp; }
      }
      if (target) { commit(target, p, U, spot); continue; }
      if (p.alt) {
        const q = altOf(p);
        const c2 = containers.find((c) => findSpot(c, q, U));
        if (c2) { tryPlace(c2, q, U); continue; }
      }
      // bölünen bloğun kalanı, sıradaki aynı tip bloklarla birleştirilip yeniden bölünür
      const requeue = (rest) => {
        const same = [rest];
        for (let i = queue.length - 1; i >= 0; i--) if (queue[i].block && queue[i].typeKey === rest.typeKey) same.push(...queue.splice(i, 1));
        queue.unshift(...rechunk(same, U));
      };
      if (p.block) {
        let rest = null;
        for (const c of containers) { rest = placeSplit(c, p, U); if (rest) break; }
        if (rest) { requeue(rest); continue; }
      }
      const c = newContainer(containers.length + 1, U);
      if (tryPlace(c, p, U)) { containers.push(c); continue; }
      const rest = placeSplit(c, p, U);
      if (rest) { containers.push(c); requeue(rest); continue; }
      unplaced.push(...(p.block ? p.members : [p]));
    }
    return { containers, unplaced };
  }

  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function centerAndStats(c, U, cont, opts) {
    let maxX = 0, minY = Infinity, maxY = 0;
    for (const p of c.placed) {
      maxX = Math.max(maxX, p.x + p.len);
      minY = Math.min(minY, p.y);
      maxY = Math.max(maxY, p.y + p.w);
    }
    if (opts.ortala && c.placed.length) {
      // yükü boyda ve ende ortala (boşluklar takoz/kalasla doldurulur)
      const sx = (U.L - maxX) / 2;
      const sy = (cont.W - (maxY - minY)) / 2 - minY;
      for (const p of c.placed) { p.x += sx; p.y += sy; }
      maxX += sx;
    }
    let mx = 0, my = 0, mz = 0, kg = 0, vol = 0, maxZ = 0;
    for (const p of c.placed) {
      mx += (p.x + p.len / 2) * p.kg;
      my += (p.y + p.w / 2) * p.kg;
      mz += (p.z + p.h / 2) * p.kg;
      kg += p.kg;
      vol += p.len * p.w * p.h * (p.petek ? 0.75 : 1); // petekte demetler iç içe geçer
      maxZ = Math.max(maxZ, p.z + p.h);
    }
    c.stats = {
      kg,
      kgPct: kg / U.maxKg,
      volPct: vol / (cont.L * cont.W * cont.H),
      loadLen: maxX,
      loadHeight: maxZ,
      // yükün en üst noktası ile konteyner tavanı / kapı üst kenarı arasındaki mesafe (mm)
      tavanBosluk: cont.H - maxZ,
      kapiBosluk: (cont.doorH || cont.H) - maxZ,
      cog: kg ? { x: mx / kg, y: my / kg, z: mz / kg } : { x: 0, y: 0, z: 0 },
      cogPctX: kg ? mx / kg / cont.L : 0,
      cogPctY: kg ? my / kg / cont.W : 0,
      packages: c.placed.length,
      petek: c.placed.some((p) => p.petek),
    };
    // yükleme sırası: arka duvardan kapıya, alttan üste, soldan sağa
    c.loadOrder = c.placed.slice().sort((a, b) => a.x - b.x || a.z - b.z || a.y - b.y).map((p) => p.id);
  }

  function rowSplits(containers) {
    let n = 0;
    for (const c of containers) n += new Set(c.placed.map((p) => p.rowId)).size;
    return n;
  }

  function lowerBound(pkgs, U) {
    const kg = pkgs.reduce((a, p) => a + p.kg, 0);
    const vol = pkgs.reduce((a, p) => a + p.len * p.w * p.h * (p.petek ? 0.75 : 1), 0);
    const lbKg = kg > 0 ? Math.ceil(kg / U.maxKg - 1e-9) : 0;
    const lbVol = vol > 0 ? Math.ceil(vol / (U.L * U.W * (U.H - U.taban)) - 1e-9) : 0;
    return { lbKg, lbVol, lb: Math.max(lbKg, lbVol) };
  }

  const cmpPlan = (a, b) =>
    a.unplaced.length - b.unplaced.length ||
    a.containers.length - b.containers.length ||
    a.splits - b.splits;

  /** Çok stratejili arama. En iyi planı ve her konteyner sayısı için en az bölünen planı döndürür. */
  function search(pkgs, U, cont, budgetMs = 350) {
    const t0 = Date.now();
    let best = null;
    const byCount = {};
    const consider = (r, name) => {
      r.strategy = name;
      r.splits = rowSplits(r.containers);
      for (const c of r.containers) { c.cont = cont; c.U = U; }
      if (!best || cmpPlan(r, best) < 0) best = r;
      if (!r.unplaced.length) {
        const k = r.containers.length;
        if (!byCount[k] || r.splits < byCount[k].splits) byCount[k] = r;
      }
    };
    const UD = { ...U, yontem: "duvar" };
    for (const [name, cmp] of Object.entries(STRATEGIES)) {
      consider(packOnce(pkgs, U, cmp, "first"), name);
      consider(packOnce(pkgs, U, cmp, "best"), name + "/en-dolu");
      consider(packOnce(pkgs, UD, cmp, "first"), name + "/duvar");
      consider(packOnce(pkgs, UD, cmp, "best"), name + "/duvar/en-dolu");
    }
    const rowIds = [...new Set(pkgs.map((p) => p.rowId))];
    const { lb } = lowerBound(pkgs, U);
    const rnd = mulberry32(12345);
    for (let it = 0; rowIds.length > 1 && it < 300 && Date.now() - t0 < budgetMs; it++) {
      if (best.containers.length <= lb && !best.unplaced.length && it > 20) break;
      const rank = {};
      rowIds.map((id) => [id, rnd()]).sort((a, b) => a[1] - b[1]).forEach(([id], i) => (rank[id] = i));
      consider(packOnce(pkgs, it % 4 < 2 ? U : UD, STRATEGIES["boy-en-kg"], it % 2 ? "best" : "first", rank), `rastgele-${it + 1}`);
    }
    if (best && !best.unplaced.length && best.containers.length > lb) {
      const e = eliminate(best, U);
      if (e.containers.length < best.containers.length) {
        e.strategy = best.strategy + "+boşaltma";
        e.splits = rowSplits(e.containers);
        best = e;
        byCount[e.containers.length] = byCount[e.containers.length] && byCount[e.containers.length].splits <= e.splits ? byCount[e.containers.length] : e;
      }
    }
    return { best: best || { containers: [], unplaced: [], strategy: "-", splits: 0 }, byCount };
  }

  /** Yerleşmiş paketleri yeniden yerleştirilebilir birimlere çevirir (petek blokları korunur). */
  function itemsFromPlaced(placed, U) {
    const strip = (p) => omit(p, YERLESIM_ALANLARI);
    const items = [];
    const blocks = new Map();
    for (const p of placed) {
      if (!p.blockId) { items.push(strip(p)); continue; }
      if (!blocks.has(p.blockId)) blocks.set(p.blockId, []);
      blocks.get(p.blockId).push(strip(p));
    }
    for (const m of blocks.values()) items.push(makeBlock(m, U));
    return items;
  }

  /** En az dolu konteynerden başlayarak, içindekileri diğerlerine dağıtıp konteyner sayısını düşürmeyi dener. */
  function eliminate(raw, U) {
    let cs = raw.containers.slice();
    let improved = true;
    while (improved && cs.length > 1) {
      improved = false;
      const order = cs.map((c, i) => i).sort((a, b) => cs[a].kg - cs[b].kg);
      for (const ti of order) {
        const items = itemsFromPlaced(cs[ti].placed, U).sort((a, b) => b.len * b.w * b.h - a.len * a.w * a.h);
        const others = cs.filter((_, i) => i !== ti).map(cloneContainer);
        let ok = true;
        for (const it of items) {
          const tgt = others.slice().sort((a, b) => b.kg - a.kg).find((c) => tryPlaceAny(c, it, U));
          if (!tgt) { ok = false; break; }
        }
        if (ok) { cs = others; improved = true; break; }
      }
    }
    return { ...raw, containers: cs };
  }

  function cloneContainer(c) {
    return { ...c, placed: c.placed.slice(), surfaces: c.surfaces.map((s) => ({ ...s })) };
  }

  /** Satırları bütün olarak yerleştirmeye çalışır (ürün bölünmesini azaltır). */
  function packRowsWhole(pkgs, U, cont, rowOrder) {
    const items = makeItems(pkgs, U);
    const groups = new Map();
    for (const p of items) {
      if (!groups.has(p.rowId)) groups.set(p.rowId, []);
      groups.get(p.rowId).push(p);
    }
    const containers = [];
    const unplaced = [];
    for (const id of rowOrder) {
      const list = (groups.get(id) || []).slice().sort((a, b) => a.partial - b.partial);
      if (!list.length) continue;
      let done = false;
      const byFill = containers.map((c, i) => [c, i]).sort((a, b) => b[0].kg - a[0].kg);
      for (const [c, i] of byFill) {
        const cl = cloneContainer(c);
        if (list.every((p) => tryPlaceAny(cl, p, U))) { containers[i] = cl; done = true; break; }
      }
      if (done) continue;
      let rest = list;
      while (rest.length) {
        const c = newContainer(containers.length + 1, U);
        const left = [];
        for (const p of rest) {
          if (tryPlaceAny(c, p, U)) continue;
          const r = placeSplit(c, p, U);
          if (r) { if (r.members.length) left.push(r); } else left.push(p);
        }
        if (!c.placed.length) { for (const p of left) unplaced.push(...(p.block ? p.members : [p])); break; }
        containers.push(c);
        const blocks = left.filter((p) => p.block);
        rest = [...left.filter((p) => !p.block), ...rechunk(blocks, U)];
      }
    }
    for (const c of containers) { c.cont = cont; c.U = U; }
    const r = { containers, unplaced, strategy: "ürün-bütün" };
    r.splits = rowSplits(containers);
    return r;
  }

  /** Ham plan -> sunulacak sonuç (kopya, numaralı, istatistikli). */
  function finalize(meta0, base, raw) {
    const { pkgs, rowInfo, U, cont, opts } = base;
    const containers = raw.containers.map((c, i) => {
      const no = i + 1;
      const nc = { no, kg: c.kg, cont: c.cont || cont, U: c.U || U, placed: c.placed.map((p) => ({ ...p, container: no })) };
      centerAndStats(nc, nc.U, nc.cont, opts);
      return nc;
    });
    const allocationsByRow = {};
    for (const c of containers) {
      for (const p of c.placed) {
        const byRow = (allocationsByRow[p.rowId] = allocationsByRow[p.rowId] || {});
        const a = (byRow[c.no] = byRow[c.no] || { packages: 0, kg: 0, pieces: 0 });
        a.packages += 1;
        a.kg += p.kg;
        a.pieces += p.pieces;
      }
    }
    const warnings = [];
    for (const c of containers) {
      const dx = Math.abs(c.stats.cogPctX - 0.5);
      const dy = Math.abs(c.stats.cogPctY - 0.5);
      if (dx > 0.1) warnings.push(`${c.no}. konteyner: ağırlık merkezi boyda %${round(c.stats.cogPctX * 100, 0)} konumunda (ortadan %${round(dx * 100, 0)} kayık).`);
      if (dy > 0.05) warnings.push(`${c.no}. konteyner: ağırlık merkezi ende %${round(c.stats.cogPctY * 100, 0)} konumunda.`);
    }
    const placedPkgs = containers.flatMap((c) => c.placed);
    const rowModlar = {};
    for (const p of placedPkgs) {
      const m = (rowModlar[p.rowId] ||= {});
      m[p.mod] = (m[p.mod] || 0) + 1;
    }
    const totalKg = pkgs.reduce((s, p) => s + p.kg, 0);
    const kgPcts = containers.map((c) => c.stats.kgPct);
    const fleet = {};
    for (const c of containers) fleet[c.cont.name] = (fleet[c.cont.name] || 0) + 1;
    const { lbKg, lbVol, lb } = lowerBound(pkgs, U);
    return {
      ...meta0,
      container: cont,
      usable: U,
      opts,
      rowInfo,
      packages: pkgs,
      containers,
      unplaced: raw.unplaced,
      strategy: raw.strategy,
      allocationsByRow,
      rowModlar,
      warnings,
      meta: {
        totalKg,
        placedKg: placedPkgs.reduce((s, p) => s + p.kg, 0),
        packageCount: pkgs.length,
        lowerBound: lb,
        lbKg,
        lbVol,
        count: containers.length,
        splits: rowSplits(containers),
        avgKgPct: kgPcts.length ? kgPcts.reduce((a, b) => a + b, 0) / kgPcts.length : 0,
        avgVolPct: containers.length ? containers.reduce((a, c) => a + c.stats.volPct, 0) / containers.length : 0,
        minKgPct: kgPcts.length ? Math.min(...kgPcts) : 0,
        maxKgPct: kgPcts.length ? Math.max(...kgPcts) : 0,
        fleet,
        ms: 0,
      },
    };
  }

  function prepare(rows, cont, opts) {
    opts = { kalanMode: "yok", ortala: true, tabanTakoz: 0, araTakoz: 0, yanBosluk: 0, farkliBoyUstUste: true, petekIzin: false, enineIzin: false, zorunlu: [], ...opts };
    const { pkgs, rowInfo, U } = buildPackages(rows, cont, opts);
    return { pkgs, rowInfo, U, cont, opts };
  }

  /**
   * Her satır için izinli modları (düz/petek × boyuna/enine) dener; en az konteyneri veren,
   * eşitlikte en verimli (konteyner başına en çok paket alan, en az hacim kullanan) kombinasyonu seçer.
   *  1) Satır tek başına: kesirli konteyner ihtiyacı (adet / konteyner kapasitesi).
   *  2) Birden fazla seçeneği olan satırlarda en iyi iki mod kombinasyonu tam aramayla denenir.
   */
  function chooseModes(rows, cont, opts, budgetMs = 900) {
    const t0 = Date.now();
    const base = buildPackages(rows, cont, opts);
    const modeMap = {}, report = {};
    const multi = [];
    for (const row of rows) {
      const info = base.rowInfo[row.id];
      if (!info || info.errors.length || !info.packages) continue;
      if (info.modlar.length <= 1) { modeMap[row.id] = info.mod; continue; }
      const scores = [];
      for (const m of info.modlar) {
        // kapasite ölçümü: satırdan bol miktarda paketle tek tip yükleme (ağırlık sınırı olmadan)
        const probe = { ...row, adet: String(info.calc.paketIci * 300) };
        const b = buildPackages([probe], { ...cont, maxKg: 1e9 }, { ...opts, kalanMode: "yok", modeMap: { [row.id]: m } });
        if (!b.pkgs.length) continue;
        const r = packOnce(b.pkgs, b.U, STRATEGIES["boy-en-kg"], "first");
        const capGeo = r.containers.length > 1 ? r.containers[0].placed.length : b.pkgs.length;
        const kgNeed = (info.packages * info.calc.paketKgRaw) / cont.maxKg;
        const geoNeed = info.packages / capGeo;
        scores.push({ mod: m, cap: Math.min(capGeo, Math.floor(cont.maxKg / info.calc.paketKgRaw)), capGeo, ihtiyac: Math.max(kgNeed, geoNeed), hacim: geoNeed });
      }
      scores.sort((a, b) => a.ihtiyac - b.ihtiyac || a.hacim - b.hacim || MODLAR.indexOf(a.mod) - MODLAR.indexOf(b.mod));
      report[row.id] = scores;
      // başlangıç: en verimli yöntem (konteyner başına en çok paket alan)
      modeMap[row.id] = scores[0]?.mod || info.mod;
      const cands = [...new Set([scores[0]?.mod, scores[1]?.mod, scores[2]?.mod].filter(Boolean))];
      if (cands.length > 1) multi.push({ id: row.id, cands });
    }
    if (!multi.length) return { modeMap, report };

    const evalMap = (mm) => {
      const b = buildPackages(rows, cont, { ...opts, modeMap: mm });
      const r = search(b.pkgs, b.U, cont, 40).best;
      // öncelik: 1) yerleşmeyen paket yok 2) en az konteyner 3) en verimli yöntemler (en az hacim ihtiyacı)
      const hacim = Object.entries(mm).reduce((s, [id, m]) => s + (report[id]?.find((x) => x.mod === m)?.hacim ?? 0), 0);
      const pen = Object.values(mm).reduce((s, m) => s + MODLAR.indexOf(m), 0);
      return { mm, key: [r.unplaced.length, r.containers.length, Math.round(hacim * 1000), pen] };
    };
    const better = (a, b) => !b || lexLess(a.key, b.key);
    let best = evalMap({ ...modeMap });
    const combos = [];
    const total = multi.reduce((n, r) => n * r.cands.length, 1);
    if (total <= 27) {
      const rec = (i, mm) => {
        if (i === multi.length) { combos.push(mm); return; }
        for (const m of multi[i].cands) rec(i + 1, { ...mm, [multi[i].id]: m });
      };
      rec(0, { ...modeMap });
    } else {
      for (const r of multi) for (const m of r.cands.slice(1)) combos.push({ ...modeMap, [r.id]: m });
    }
    for (const mm of combos) {
      if (Date.now() - t0 > budgetMs) break;
      const e = evalMap(mm);
      if (better(e, best)) best = e;
    }
    return { modeMap: best.mm, report };
  }

  /** En az konteynerli tek plan (geriye dönük uyumluluk). */
  function plan(rows, cont, opts = {}) {
    const t0 = Date.now();
    const o2 = { ...opts };
    if (!o2.modeMap && (o2.petekIzin || o2.enineIzin)) o2.modeMap = chooseModes(rows, cont, prepare(rows, cont, o2).opts, 400).modeMap;
    const base = prepare(rows, cont, o2);
    const S = search(base.pkgs, base.U, cont, opts.zamanMs ?? 400);
    const r = finalize({ key: "enaz", title: "En az konteyner" }, base, S.best);
    r.meta.ms = Date.now() - t0;
    return r;
  }

  const fleetText = (fleet) => Object.entries(fleet).map(([n, k]) => `${k} × ${n}`).join(" + ");

  /**
   * Elle verilmiş dağılımı (ör. Excel'deki plan) yerleştirip değerlendirir.
   * manuel: [{ [rowId]: paketSayısı, ... }, ...] konteyner başına.
   */
  function planManual(base, manuel, meta0) {
    const { pkgs, U, cont } = base;
    const used = new Set();
    const raw = { containers: [], unplaced: [], strategy: "excel" };
    let fits = true;
    for (const alloc of manuel) {
      const sub = [];
      for (const [rowId, n] of Object.entries(alloc)) {
        const avail = pkgs.filter((p) => p.rowId === rowId && !used.has(p.id)).slice(0, n);
        avail.forEach((p) => used.add(p.id));
        sub.push(...avail);
      }
      const R = search(sub, U, cont, 120).best;
      if (R.containers.length !== 1 || R.unplaced.length) fits = false;
      raw.containers.push(...R.containers);
      raw.unplaced.push(...R.unplaced);
    }
    raw.unplaced.push(...pkgs.filter((p) => !used.has(p.id)));
    const M = finalize(meta0, base, raw);
    M.manualFits = fits;
    return M;
  }

  /**
   * Her ürünü n konteynere eşit böler ve her konteyneri ayrı yerleştirir; ağır paket hafifin
   * üstüne konmaz. Elle yapılan planlardaki düzen: her konteynerde aynı karışım, aynı boydaki
   * hafif paketler (ör. 127'lik) en üstte. Sığmazsa null.
   */
  function esitKarisim(pkgs, U, cont, n) {
    const U2 = { ...U, hafifUstte: true };
    const byRow = new Map();
    for (const p of pkgs) {
      if (!byRow.has(p.rowId)) byRow.set(p.rowId, []);
      byRow.get(p.rowId).push(p);
    }
    const subs = Array.from({ length: n }, () => []);
    let off = 0;
    for (const list of byRow.values()) {
      const taban = Math.floor(list.length / n), kalan = list.length % n;
      let i = 0;
      for (let c = 0; c < n; c++) {
        const adet = taban + ((c - off + n) % n < kalan ? 1 : 0);
        subs[c].push(...list.slice(i, i + adet));
        i += adet;
      }
      off = (off + kalan) % n; // artanlar konteynerlere sırayla dağılır
    }
    const raw = { containers: [], unplaced: [], strategy: "esit-karisim" };
    for (const sub of subs) {
      if (!sub.length) continue;
      const R = search(sub, U2, cont, 80).best;
      if (R.containers.length !== 1 || R.unplaced.length) return null;
      raw.containers.push(R.containers[0]);
    }
    raw.splits = rowSplits(raw.containers);
    return raw;
  }

  /**
   * Alternatif planlar:
   *  - En az konteyner (önerilen)
   *  - Tonajı eşit dağıt: aynı sayıda konteyner, yükler birbirine yakın
   *  - Ürünleri bölmeden: her ürün mümkün olduğunca tek konteynerde
   *  - Karma filo: en hafif konteynerin yükü 20'ye sığıyorsa
   *  - Diğer konteyner tipleriyle karşılaştırma
   *  - Elle yapılmış plan (verildiyse) ile karşılaştırma
   */
  function planAlternatives(rows, cont, opts = {}, extra = {}) {
    const t0 = Date.now();
    const full = prepare(rows, cont, opts).opts;
    const secim = full.modeMap ? { modeMap: full.modeMap, report: {} } : chooseModes(rows, cont, full);
    opts = { ...full, modeMap: secim.modeMap };
    const base = prepare(rows, cont, opts);
    const { pkgs, U } = base;
    const alts = [];
    const S = search(pkgs, U, cont, 600);
    const A = finalize({ key: "enaz", title: "En az konteyner", desc: "Konteyner sayısını en aza indirir. Önerilen plan." }, base, S.best);
    alts.push(A);
    A.modRaporu = secim.report;
    const n = A.meta.count;
    if (!pkgs.length || !n) return { alternatives: alts, ms: Date.now() - t0 };

    // 1b) Yöntem karşılaştırması: petek/enine kullanılmasaydı
    {
      const dbMap = {};
      let fark = false;
      for (const [id, info] of Object.entries(base.rowInfo)) {
        if (!info.packages) continue;
        if (info.modlar.includes("duz-boyuna")) { dbMap[id] = "duz-boyuna"; if (info.mod !== "duz-boyuna" || Object.keys(A.rowModlar[id] || {}).some((m) => m !== "duz-boyuna")) fark = true; }
        else dbMap[id] = info.mod;
      }
      if (fark) {
        const b2 = prepare(rows, cont, { ...opts, modeMap: dbMap, karmaYon: false });
        const R = search(b2.pkgs, b2.U, cont, 250).best;
        const D = finalize({ key: "duzboyuna", title: "Yalnız düz · boyuna", desc: "" }, b2, R);
        const diff = D.meta.count - n;
        D.desc = diff > 0
          ? `Petek/enine yöntemler kullanılmasaydı ${D.meta.count} konteyner gerekirdi (${diff} fazla). Seçilen yöntemler ${diff} konteyner kazandırıyor.`
          : `Yalnız düz boyuna yüklemeyle de ${D.meta.count} konteyner; ama hacim doluluğu daha düşük (ort. %${round(D.meta.avgVolPct * 100, 0)}, seçilen planda %${round(A.meta.avgVolPct * 100, 0)}).`;
        alts.push(D);
      }
    }

    // 1c) Eşit karışım: her konteynerde aynı ürün karışımı, hafif paketler üstte
    if (n > 1 && new Set(pkgs.map((p) => p.rowId)).size > 1) {
      const R = esitKarisim(pkgs, U, cont, n);
      if (R) {
        const K = finalize({
          key: "karisim",
          title: "Eşit karışım, hafif paketler üstte",
          desc: "Her ürün konteynerlere eşit bölünür; aynı boydaki hafif paketler ağırların üstüne konur. Boşaltmada üstten önce alınır, tonaj konteynerler arasında dengeli olur.",
        }, base, R);
        if (U.hafifUstte) {
          // müşteri kuralı hafif paketleri üstte istiyor: aynı konteyner sayısında bu düzen önerilir
          K.desc += " Müşteri kuralı gereği önerilen plan.";
          K.modRaporu = A.modRaporu;
          alts.unshift(K);
        } else alts.push(K);
      }
    }

    // 2) Tonajı eşit dağıt
    if (n > 1) {
      const totalKg = pkgs.reduce((s, p) => s + p.kg, 0);
      const maxP = Math.max(...pkgs.map((p) => p.kg));
      for (let k = 0; k <= 12; k++) {
        const cap = Math.min(U.maxKg, totalKg / n + (k * maxP) / 3);
        const R = search(pkgs, { ...U, maxKg: cap }, cont, 120).best;
        if (!R.unplaced.length && R.containers.length === n) {
          for (const c of R.containers) c.U = U;
          const B = finalize({ key: "dengeli", title: "Tonajı eşit dağıt", desc: "Aynı sayıda konteyner; yük konteynerler arasında eşit bölünür. Dorse/aks yükü ve gümrük tartımı için dengeli." }, base, R);
          if (B.meta.maxKgPct - B.meta.minKgPct < A.meta.maxKgPct - A.meta.minKgPct - 0.03) alts.push(B);
          break;
        }
        if (cap >= U.maxKg) break;
      }
    }

    // 3) Ürünleri bölmeden
    {
      const rowIds = [...new Set(pkgs.map((p) => p.rowId))];
      const totals = {}, lens = {};
      for (const p of pkgs) { totals[p.rowId] = (totals[p.rowId] || 0) + p.kg; lens[p.rowId] = Math.max(lens[p.rowId] || 0, p.len); }
      const orders = [
        rowIds.slice().sort((a, b) => totals[b] - totals[a]),
        rowIds.slice().sort((a, b) => totals[a] - totals[b]),
        rowIds.slice().sort((a, b) => lens[b] - lens[a] || totals[b] - totals[a]),
      ];
      const rnd = mulberry32(777);
      for (let i = 0; i < 40; i++) orders.push(rowIds.map((id) => [id, rnd()]).sort((a, b) => a[1] - b[1]).map((x) => x[0]));
      const cands = [...orders.map((o) => packRowsWhole(pkgs, U, cont, o)), ...orders.slice(0, 20).map((o) => packRowsWhole(pkgs, { ...U, yontem: "duvar" }, cont, o))];
      if (S.byCount[n]) cands.push(S.byCount[n]);
      if (S.byCount[n + 1]) cands.push(S.byCount[n + 1]);
      const ok = cands.filter((r) => !r.unplaced.length && r.containers.length <= n + 1);
      ok.sort((a, b) => a.splits - b.splits || a.containers.length - b.containers.length);
      const R = ok[0];
      if (R && R.splits < A.meta.splits) {
        const ex = R.containers.length - n;
        alts.push(finalize({ key: "butun", title: "Ürünleri bölmeden", desc: `Her ürün mümkün olduğunca tek konteynerde: ${R.splits - rowIds.length} bölünme (en az konteyner planında ${A.meta.splits - rowIds.length}).${ex ? ` ${ex} konteyner fazla.` : " Konteyner sayısı aynı."}` }, base, R));
      }
    }

    // 4) Karma filo: en hafif konteyner 20'ye sığıyor mu?
    const C20 = CONTAINER_TYPES["20DC"];
    if (cont.L > 10000 && n >= 1) {
      const raw = S.best.containers.slice().sort((a, b) => a.kg - b.kg);
      const light = raw[0];
      const lpk = light.placed.map((p) => omit(p, YERLESIM_ALANLARI));
      if (lpk.every((p) => p.len <= C20.L)) {
        const U20 = usable(C20, base.opts);
        const R = search(lpk, U20, C20, 150).best;
        if (!R.unplaced.length && R.containers.length === 1) {
          const mixed = { containers: [...raw.slice(1).sort((a, b) => b.kg - a.kg), R.containers[0]], unplaced: [], strategy: "karma" };
          const M = finalize({ key: "karma", title: "Karma filo", desc: `Son konteynerdeki ${round(light.kg / 1000, 1)} t yük 20'lik konteynere sığıyor. Navlun farkını değerlendirin.` }, base, mixed);
          M.title = `Karma: ${fleetText(M.meta.fleet)}`;
          alts.push(M);
        }
      }
    }

    // 5) Diğer konteyner tipleri
    for (const [key, T] of Object.entries(CONTAINER_TYPES)) {
      if (T.name === cont.name && T.L === cont.L && T.H === cont.H) continue;
      const Tc = { ...T, maxKg: cont.maxKg };
      const b2 = prepare(rows, Tc, base.opts);
      const lost = Object.entries(b2.rowInfo).filter(([id, info]) => info.errors.length && !base.rowInfo[id]?.errors.length).length;
      const S2 = search(b2.pkgs, b2.U, Tc, 150);
      const R = finalize({ key: "tip-" + key, title: `Sadece ${T.name}`, desc: lost ? `${lost} satır bu konteynere sığmıyor ve plan dışında kalıyor.` : `Tüm sipariş ${T.name} ile.`, excludedRows: lost }, b2, S2.best);
      if (R.meta.count) alts.push(R);
    }

    // 6) Elle yapılmış plan
    if (extra.manuel?.length) {
      const mb = prepare(rows, cont, { ...opts, modeMap: Object.fromEntries(rows.map((r) => [r.id, "duz-boyuna"])) });
      const M = planManual(mb, extra.manuel, { key: "manuel", title: extra.manuelAd || "Mevcut plan (Excel)", desc: "" });
      const v = validate(M);
      M.desc = (M.manualFits && v.ok && !M.unplaced.length)
        ? `Excel'deki dağılım bu kurallarla fiziksel olarak sığıyor. ${M.meta.count} konteyner.`
        : `Excel'deki dağılım bu kurallarla sığmıyor: ${M.unplaced.length ? `${M.unplaced.length} paket yerleşmedi` : "doğrulama hatası"}.`;
      alts.push(M);
    }

    return { alternatives: alts, ms: Date.now() - t0 };
  }

  // ---------------------------------------------------------------- doğrulama

  function overlap1(a0, a1, b0, b1) {
    return Math.min(a1, b1) - Math.max(a0, b0);
  }

  /** Paketleri doğrulama kutularına çevirir: petek blokları tek kutu olarak ele alınır. */
  function boxesOf(c) {
    const boxes = [];
    const blocks = new Map();
    for (const p of c.placed) {
      if (!p.blockId) { boxes.push({ x: p.x, y: p.y, z: p.z, len: p.len, w: p.w, h: p.h, boy: p.boy, kg: p.kg, block: false, n: 1 }); continue; }
      const b = blocks.get(p.blockId);
      if (!b) blocks.set(p.blockId, { x: p.x, y: p.y, z: p.z, x1: p.x + p.len, y1: p.y + p.w, z1: p.z + p.h, boy: p.boy, n: 1, members: [p] });
      else {
        b.x = Math.min(b.x, p.x); b.y = Math.min(b.y, p.y); b.z = Math.min(b.z, p.z);
        b.x1 = Math.max(b.x1, p.x + p.len); b.y1 = Math.max(b.y1, p.y + p.w); b.z1 = Math.max(b.z1, p.z + p.h); b.n++; b.members.push(p);
      }
    }
    for (const b of blocks.values()) boxes.push({ x: b.x, y: b.y, z: b.z, len: b.x1 - b.x, w: b.y1 - b.y, h: b.z1 - b.z, boy: b.boy, kg: b.members.reduce((t, m) => t + m.kg, 0), block: true, n: b.n, members: b.members });
    return boxes;
  }

  /** Petek bloğunun içini kontrol eder: altıgenler (köşe yukarı) çakışmamalı ve oluğa oturmalı. */
  function petekIcHatasi(members) {
    let bad = 0;
    for (let i = 0; i < members.length; i++) {
      const a = members[i];
      // sıra yönü: boyunada konteyner eni (y), eninede konteyner boyu (x)
      const ca = a.enine ? a.x + a.len / 2 : a.y + a.w / 2;
      const wf = a.enine ? a.len : a.w;
      for (let j = i + 1; j < members.length; j++) {
        const b = members[j];
        const cb = b.enine ? b.x + b.len / 2 : b.y + b.w / 2;
        const d = Math.abs(ca - cb);
        const dz = Math.abs((a.z + a.h / 2) - (b.z + b.h / 2));
        if (dz < 1 && d < wf - 1) bad++;
        else if (dz > 1 && dz < a.h * PETEK_PITCH - 1 && d < wf - 1) bad++;
        else if (Math.abs(dz - a.h * PETEK_PITCH) < 1 && d < wf / 2 - 1) bad++;
      }
    }
    return bad;
  }

  /** Planın fiziksel olarak tutarlı olduğunu bağımsız olarak kontrol eder. */
  function validate(result) {
    const U0 = result.usable;
    const checks = [];
    const add = (name, ok, detail) => checks.push({ name, ok, detail });

    const seen = new Map();
    for (const c of result.containers) for (const p of c.placed) seen.set(p.id, (seen.get(p.id) || 0) + 1);
    const dup = [...seen.values()].filter((n) => n > 1).length;
    const missing = result.packages.filter((p) => !seen.has(p.id)).length;
    add("Her paket bir kez yerleşti", dup === 0 && missing === 0,
      missing ? `${missing} paket yerleşmedi` : dup ? `${dup} paket iki kez yerleşti` : `${seen.size} paket`);

    let outOf = 0, over = 0, heavy = 0, unsupported = 0, high = 0, mixedLen = 0, petekBad = 0, petekBlocks = 0, agirUstte = 0;
    for (const c of result.containers) {
      const cont = c.cont || result.container;
      const U = c.U || result.usable;
      const B = boxesOf(c);
      for (const p of B) {
        if (p.x < -EPS || p.y < -EPS || p.z < -EPS || p.x + p.len > cont.L + EPS || p.y + p.w > cont.W + EPS || p.z + p.h > cont.H + EPS) outOf += p.n;
        if (p.z + p.h > U.H + EPS) high += p.n;
        if (p.block) { petekBlocks++; petekBad += petekIcHatasi(p.members); }
      }
      for (let i = 0; i < B.length; i++) {
        const a = B[i];
        for (let j = i + 1; j < B.length; j++) {
          const b = B[j];
          if (overlap1(a.x, a.x + a.len, b.x, b.x + b.len) > EPS &&
              overlap1(a.y, a.y + a.w, b.y, b.y + b.w) > EPS &&
              overlap1(a.z, a.z + a.h, b.z, b.z + b.h) > EPS) over++;
        }
      }
      if (c.kg > U.maxKg + 1e-6) heavy++;
      // destek: zeminde değilse taban alanının en az %60'ı alttaki paketlere oturmalı
      for (const a of B) {
        if (a.z <= U.taban + EPS) continue;
        if (a.block) { unsupported += a.n; continue; }
        let area = 0;
        for (const b of B) {
          if (Math.abs(b.z + b.h + U.ara - a.z) > 1) continue;
          const ox = overlap1(a.x, a.x + a.len, b.x, b.x + b.len);
          const oy = overlap1(a.y, a.y + a.w, b.y, b.y + b.w);
          if (ox > 0 && oy > 0) {
            area += ox * oy;
            if (Math.abs(b.boy - a.boy) > EPS) mixedLen++;
            if (a.kg > b.kg + 1) agirUstte++;
          }
        }
        if (area < 0.6 * a.len * a.w) unsupported++;
      }
    }
    add("Konteyner sınırları içinde", outOf === 0, outOf ? `${outOf} paket dışarı taşıyor` : "taşma yok");
    add("Paketler çakışmıyor", over === 0, over ? `${over} çakışan çift` : "çakışma yok");
    add("Ağırlık limiti", heavy === 0, heavy ? `${heavy} konteyner limiti aşıyor` : `≤ ${U0.maxKg.toLocaleString("tr-TR")} kg`);
    const minT = Math.max(...result.containers.map((c) => (c.U || result.usable).minTavan || 0), 0);
    add(minT ? `Yük yüksekliği (kapı ve tavana en az ${minT} mm)` : "Kapıdan geçiş yüksekliği", high === 0,
      high ? `${high} paket sınırın üstünde` : minT ? "kapı ve tavan boşluğu sınırı aşılmıyor" : "kapı yüksekliği aşılmıyor");
    add("Her paket alttan destekli", unsupported === 0, unsupported ? `${unsupported} paket boşlukta` : "boşlukta paket yok");
    if (result.containers.some((c) => (c.U || U0).hafifUstte)) add("Ağır paket hafifin üstünde değil", agirUstte === 0, agirUstte ? `${agirUstte} ağır paket hafif paketin üstünde` : "hafif paketler üstte");
    if (U0.farkliBoyYasak) add("Farklı boylar üst üste değil", mixedLen === 0, mixedLen ? `${mixedLen} farklı boy teması` : "müşteri kuralına uygun");
    if (petekBlocks) add("Petek dizilim geometrisi", petekBad === 0, petekBad ? `${petekBad} hatalı oturma` : `${petekBlocks} petek bloğu`);
    add("Teorik alt sınır", true,
      result.meta.fleet && Object.keys(result.meta.fleet).length > 1
        ? `karma filo: ${result.meta.count} konteyner`
        : result.meta.count === result.meta.lowerBound
          ? `${result.meta.count} konteyner = alt sınır (daha azı imkânsız)`
          : `${result.meta.count} konteyner, alt sınır ${result.meta.lowerBound}`);
    return { ok: checks.every((c) => c.ok), checks };
  }

  // ---------------------------------------------------------------- deneme siparişleri
  const R = (id, kalinlik, ebat, boy, paketIci, bantEni, adet, dizilim) => ({ id, kalinlik: String(kalinlik), ebat: String(ebat), boy: String(boy), paketIci: String(paketIci), bantEni: String(bantEni), adet: String(adet), dizilim: dizilim || "otomatik" });
  const SAMPLE_ORDERS = [
    {
      id: "DEMO-01", musteri: "Demo Müşteri 1", varis: "—", tarih: "2026-10-14", profil: "ramsteel",
      not: "Örnek sipariş. Q35 × 2970 talimat gereği petek dizilir; elle yapılmış 4 konteynerlik plan da karşılaştırmaya eklenir.",
      rows: [R("q1", 0.82, 35, 2970, 217, 109, 21700), R("q2", 0.82, 38, 3370, 169, 119, 5408), R("q3", 0.82, 38, 7220, 127, 119, 1016), R("q4", 0.82, 38, 7220, 169, 119, 4056)],
      manuel: [{ q2: 16, q3: 4, q4: 12 }, { q2: 16, q3: 4, q4: 12 }, { q1: 50 }, { q1: 50 }],
      manuelAd: "Elle yapılmış plan",
    },
    {
      id: "DEMO-02", musteri: "Demo Müşteri 1", varis: "—", tarih: "2026-10-16", profil: "ramsteel",
      not: "Talimattaki yan görünüş çizimi: 7250 ve 3383 mm boyuna, 2025 mm'lik 8 paket kapı tarafındaki boşluğa enine. Motor aynı yerleşimi kendisi bulur.",
      rows: [R("k1", 0.9, 38, 2025, 169, 119, 1352), R("k2", 0.9, 38, 3383, 169, 119, 2028), R("k3", 0.9, 38, 7250, 169, 119, 2028), R("k4", 0.9, 38, 7250, 127, 119, 508)],
    },
    {
      id: "DEMO-03", musteri: "Demo Müşteri 2", varis: "—", tarih: "2026-10-19", profil: "northwest",
      not: "Örnek sipariş (168 t). Elle yapılmış planda 8 konteyner (her biri 16+12+4 paket). Talimat kurallarıyla (taban 210, 3×10 ara takoz, Q38 düz) en az 8; ara takozsuz 7 çıkar.",
      rows: [R("n1", 0.82, 38, 3376, 169, 119, 21632), R("n2", 0.82, 38, 7220, 169, 119, 16224), R("n3", 0.82, 38, 7220, 127, 119, 4064)],
      manuel: Array.from({ length: 8 }, () => ({ n1: 16, n2: 12, n3: 4 })),
      manuelAd: "Elle yapılmış plan",
    },
    {
      id: "DEMO-04", musteri: "Demo Müşteri 2", varis: "—", tarih: "2026-10-19", profil: "northwest",
      not: "2955 mm örnek sipariş (45,9 t). Elle yapılmış planda 2 konteyner (her biri 48+16 paket); ton alt sınırı da 2.",
      rows: [R("w1", 0.82, 38, 2955, 169, 119, 16224), R("w2", 0.82, 38, 2955, 127, 119, 4064)],
      manuel: [{ w1: 48, w2: 16 }, { w1: 48, w2: 16 }],
      manuelAd: "Elle yapılmış plan",
    },
    {
      id: "SP-2026-0418", musteri: "Örnek Müşteri A", varis: "Hamburg", tarih: "2026-10-14", profil: "genel",
      not: "Karışık çap, çoğu 6 m, bir kalem 12 m. Tonaj belirleyici.",
      rows: [
        R("a1", 1.5, 40, 6000, 61, 125, 3000), R("a2", 2, 60, 6000, 37, 188, 1100), R("a3", 1.2, 25, 6000, 127, 78, 4500),
        R("a4", 2.5, 50.8, 12000, 61, 160, 700), R("a5", 1.2, 89, 6000, 37, 280, 900),
      ],
    },
    {
      id: "SP-2026-0422", musteri: "Örnek Müşteri B", varis: "Houston", tarih: "2026-10-17", profil: "genel",
      not: "12 m kalın cidarlı borular. Ağır, konteynerler tonajdan dolar.",
      rows: [R("b1", 3, 60.3, 12000, 37, 189, 900), R("b2", 3.5, 76.1, 12000, 37, 239, 600), R("b3", 2.5, 48.3, 12000, 61, 152, 900)],
    },
    {
      id: "SP-2026-0425", musteri: "Örnek Müşteri C", varis: "Erbil", tarih: "2026-10-20", profil: "genel",
      not: "İnce cidarlı büyük çaplar. Hafif ama hacimli; konteynerler hacimden dolar. Petek dizilimi seçerek farkı görün.",
      rows: [R("c1", 1, 88.9, 6000, 37, 279, 1480), R("c2", 1.2, 101.6, 6000, 37, 319, 740), R("c3", 0.8, 76.1, 6000, 37, 239, 1110)],
    },
    {
      id: "SP-2026-0431", musteri: "Örnek Müşteri D", varis: "Kazablanka", tarih: "2026-10-23", profil: "genel",
      not: "5,8 m kısa boylar. Son konteyner az dolu; 20'lik ile karma filo seçeneği çıkar.",
      rows: [R("d1", 2, 40, 5800, 61, 160, 2440), R("d2", 1.5, 30, 5800, 91, 120, 3640), R("d3", 2, 50, 5800, 61, 200, 610)],
    },
    {
      id: "SP-2026-0440", musteri: "Örnek Müşteri F", varis: "Lyon", tarih: "2026-10-29", profil: "genel",
      not: "Hafif, kısa boylar (2.200 ve 2.300 mm). Boyuna dizilince konteyner boyunda fire kalıyor; enine yükleme konteyner kazandırıyor.",
      rows: [R("f1", 1, 76.1, 2200, 37, 239, 7770), R("f2", 1.2, 60.3, 2300, 61, 189, 488)],
    },
    {
      id: "SP-2026-0436", musteri: "Örnek Müşteri E", varis: "Köstence", tarih: "2026-10-27", profil: "genel",
      not: "3, 4 ve 6 m karışık boylar. Boyda arka arkaya diziliş ve fire görülür.",
      rows: [R("e1", 1.5, 32, 3000, 91, 100, 3640), R("e2", 2, 42.4, 4000, 61, 133, 1830), R("e3", 1.8, 48.3, 6000, 61, 152, 1220), R("e4", 1.2, 20, 6000, 127, 63, 2540)],
    },
  ];
  /**
   * Müşteri linki için bir alternatifin sade görüntüsü: 3D'de çizmeye yeten yerleşim
   * + konteyner istatistikleri. Hesap ayrıntıları (kurallar, motor seçenekleri) taşınmaz.
   * satirlar: [{ id, etiket, renk, paketIci }]
   */
  function shareSnapshot(alt, satirlar, kurallar = []) {
    const r1 = (v) => Math.round(toNum(v) * 10) / 10;
    const r4 = (v) => Math.round(toNum(v) * 1e4) / 1e4;
    const containers = alt.containers.map((c) => ({
      no: c.no,
      cont: { name: c.cont.name, L: c.cont.L, W: c.cont.W, H: c.cont.H, doorH: c.cont.doorH || c.cont.H },
      U: { taban: c.U.taban, ara: c.U.ara, maxKg: c.U.maxKg, minTavan: c.U.minTavan || 0 },
      stats: {
        kg: r1(c.stats.kg), kgPct: r4(c.stats.kgPct), volPct: r4(c.stats.volPct),
        loadLen: r1(c.stats.loadLen), loadHeight: r1(c.stats.loadHeight),
        tavanBosluk: r1(c.stats.tavanBosluk ?? c.cont.H - c.stats.loadHeight),
        kapiBosluk: r1(c.stats.kapiBosluk ?? (c.cont.doorH || c.cont.H) - c.stats.loadHeight),
        packages: c.placed.length,
        cog: { x: r1(c.stats.cog.x), y: r1(c.stats.cog.y), z: r1(c.stats.cog.z) },
      },
      loadOrder: c.loadOrder || c.placed.map((p) => p.id),
      placed: c.placed.map((p) => {
        const o = { id: p.id, rowId: String(p.rowId), typeKey: p.typeKey, mod: p.mod, k: p.k, x: r1(p.x), y: r1(p.y), z: r1(p.z), len: r1(p.len), w: r1(p.w), h: r1(p.h), kg: r1(p.kg), pieces: p.pieces };
        if (p.petek) o.petek = true;
        if (p.enine) o.enine = true;
        if (p.partial) o.partial = true;
        if (p.blockId != null) o.blockId = String(p.blockId);
        return o;
      }),
    }));
    const placedAll = containers.flatMap((c) => c.placed);
    return {
      containers,
      satirlar: satirlar.map((s) => {
        const mine = placedAll.filter((p) => p.rowId === String(s.id));
        const modlar = {};
        for (const p of mine) modlar[p.mod] = (modlar[p.mod] || 0) + 1;
        return { id: String(s.id), etiket: s.etiket, renk: s.renk, paketIci: toNum(s.paketIci), paket: mine.length, kg: r1(mine.reduce((t, p) => t + p.kg, 0)), modlar };
      }),
      meta: { count: containers.length, placedKg: r1(alt.meta.placedKg), avgKgPct: r4(alt.meta.avgKgPct), fleet: { ...alt.meta.fleet } },
      kurallar: kurallar.map((k) => ({ ad: k.ad, ...(k.madde ? { madde: String(k.madde) } : {}) })),
    };
  }

  const SAMPLE_ROWS = SAMPLE_ORDERS[1].rows.map((r, i) => ({ ...r, id: "r" + (i + 1) }));

  return {
    SAMPLE_ORDERS, SAMPLE_ROWS, MUSTERI_PROFILLERI, DENSITY, HEX_RATIO, PAKET_ICI_MAP, CONTAINER_TYPES,
    MODLAR, MOD_ADI, profilOpts, kuralOpts, chooseModes,
    calcRow, buildPackages, petekGeom, usable, plan, planAlternatives, validate, round, toNum, hexCount, shareSnapshot,
  };
});
